/**
 * Document Type Enum
 *
 * Represents the type of document content detected through classification.
 * Used across workflow steps to determine processing logic.
 */
export enum DocumentType {
  PURCHASE_ORDER = "purchase_order",
  AP_INVOICE = "ap_invoice",
  AP_INVOICE_UPDATE = "ap_invoice_update",
  REMITTANCE_ADVICE = "remittance_advice",
  LEAD_TIME_SHEET = "lead_time_sheet",
  /** Carrier rate/load confirmation issued before pickup. Often a supporting doc for an AP invoice. */
  CARRIER_CONFIRMATION = "carrier_confirmation",
  /** Bill of Lading (straight or master) issued by carrier/shipper for in-transit freight. */
  BILL_OF_LADING = "bill_of_lading",
  /** Signed delivery receipt confirming goods were delivered (often a stamped/signed BOL). */
  PROOF_OF_DELIVERY = "proof_of_delivery",
  /** Document annotated with a receiving stamp/sticker indicating quantities received at the buyer's warehouse. */
  RECEIVING_STAMP = "receiving_stamp",
  /** A receipt (e.g. lumper/unloading receipt, misc service receipt) often attached to a freight/AP invoice as backup for a charge line. */
  RECEIPT = "receipt",
  /** Discount Request form a distributor sends ahead of a purchase order, asking for approved exception pricing on specific items. Feeds Discounts v2 ingestion. */
  DISCOUNT_REQUEST = "discount_request",
  /** Vendor/supplier pricelist uploaded via the Item Master pricelist management feature. */
  IM_PRICELISTS = "im_pricelists",
  /** Special Pricing Agreement (SPA) vendor price file, typically an Excel sheet extracted from a vendor portal ZIP. */
  PRICING_SPA = "pricing_spa",
  /**
   * A file that went through the CSV → XLSX converter utility: both the
   * uploaded delimited source and the workbook produced from it (the workbook's
   * File carries the source's file id as `parentFileId`). Deliberately generic —
   * these are whatever CSVs users need converted, not always pricelists.
   */
  CSV_CONVERSION = "csv_conversion",
  OTHER = "other",
  /** Parent document that was split into multiple child documents. Not eligible for classification. */
  MULTI_DOC_PARENT = "multi_doc_parent",
}
